import HelpCenter from '@/models/HelpCenter'
import Api from '@/services/api'
import { each, find } from 'lodash'

export default {
  namespaced: true,
  state: {
    list: [],
    listMeta: {
      current_page: 0,
      last_page: 1
    },
    hellpCenterDetails: {}
  },

  actions: {
    /**
     * Get reported jobs
     *
     * @param {*} commit
     * @param {Object} params
     */
    async getHelpCenter({ commit }, params) {
      const query = HelpCenter.page(params.page || 1)

      if (params.search) {
        query.where('search', params.search)
      }

      const res = await query.params({ limit: 20 }).get()

      commit('setHelpCenterList', res.data)
      commit('setHelpCenterListMeta', res.meta)
    },

    /**
     * Get the details of help center
     *
     * @param {*} commit
     * @param {BigInteger} jobId
     */
    async getHelpCenterDetails({ commit }, jobId) {
      const response = await Api.get(`reported-jobs/${jobId}`)

      commit('setHelpCenterDetails', response.data.data)
    }
  },

  mutations: {
    /**
     * Set the state of help center details
     *
     * @param {*} state
     * @param {Object} details
     */
    setHelpCenterDetails(state, details) {
      state.helpCenterDetails = details
    },

    /**
     * Set state of help center list
     *
     * @param {*} state
     * @param {Object} reports
     */
    setHelpCenterList(state, reports) {
      each(reports, report => {
        const exist = find(state.list, { id: report.id })
        if (!exist) {
          state.list.push(new HelpCenter(report))
        }
      })
    },

    /**
     * Set the state of reported jobs list to empty
     *
     * @param {*} state
     */
    clearHelpCenterList(state) {
      state.list = []
    },

    /**
     * Set the state of reported jobs list meta
     *
     * @param {*} state
     */
    setHelpCenterListMeta(state, meta) {
      state.listMeta = meta
    }
  }
}
